// extracted by mini-css-extract-plugin
module.exports = {"Nav":"Nav_Nav__cViw5","LogoOrder":"Nav_LogoOrder__hrz16","Flex":"Nav_Flex__3m8rt"};